import {createFileRoute, Outlet, useLocation, useNavigate} from '@tanstack/react-router'
import {Container, Tabs, Title} from "@mantine/core";
import {IconCalendar, IconIceCream2, IconPlus} from "@tabler/icons-react";

export const Route = createFileRoute('/_authenticated/_dailymenu')({
	component: RouteComponent,
})

function RouteComponent() {
	const navigate = useNavigate()
	const path = useLocation({select: (state) => state.pathname})

	const defPath = path.replace("/dailymenu", "").replace("/", "")

	return (
		<Container fluid>
			<Title>Denní nabídka</Title>
			<Tabs value={defPath == "" ? "today" : defPath} onChange={(val) => {
				if (val == "today") navigate({to: "/dailymenu"})
				else navigate({to: `/dailymenu/${val}`})
			}}>
				<Tabs.List>
					<Tabs.Tab value={"today"} leftSection={<IconIceCream2/>}>
						Dnes
					</Tabs.Tab>
					<Tabs.Tab value={"day"} leftSection={<IconCalendar/>}>Jiný den</Tabs.Tab>
					<Tabs.Tab value={"new"} leftSection={<IconPlus/>} ml={"auto"}>Vytvořit</Tabs.Tab>
				</Tabs.List>
				<Outlet/>
			</Tabs>
		</Container>
	)
}
